import declare from 'dojo/_base/declare';

/**
 * A decorator that converts a TypeScript class into a declare constructor.
 * This allows declare constructors to be defined as classes, which nicely
 * hides away the `declare([], {})` boilerplate.
 */
export default function (...mixins: any[]) {
    // Optional leading string argument = the explicit dojo declaredClass name.
    // Legacy widgets used declare("Some.Dotted.Name", [bases], {...}); that name is
    // registered as a global (dojo.setObject) and is how dotted data-dojo-type refs
    // resolve (dojo/parser getObject). Passing it here preserves that 1:1. When
    // omitted, we fall back to the TypeScript class name (target.name).
    let explicitName: string | null = (typeof mixins[0] === "string") ? mixins.shift() : null;

    return function (target: Function) {
        let targetType: any = target;
        let declaredName: any = explicitName != null
            ? explicitName
            // für IE: target.name may be undefined -> let declare derive an anonymous class
            : (typeof (targetType.name) == "undefined" ? undefined : targetType.name);

        if (declaredName === undefined) {
            return declare(mixins, target.prototype);
        }
        else {
            return declare(declaredName, mixins, target.prototype);
        }
    };
};
